import { useSelector } from 'react-redux';
import { selectColoEnabled, selectMiningEnabled } from 'store/features';

// Guard hook (Plan 06 §Key contracts): miningEnabled defaults to visible (undefined/null/true
// all read as visible; only an explicit `mining:false` hides mining surfaces). coloEnabled only
// renders once the org's flags have explicitly resolved to `colo:true`.
export const useFeatures = () => {
  const miningEnabled = useSelector(selectMiningEnabled);
  const coloEnabled = useSelector(selectColoEnabled);

  return { miningEnabled, coloEnabled };
};

export default useFeatures;
